<template>
  <v-row class="background rounded-lg">
    <v-col cols="12">
      <copy-text-field :link="link"></copy-text-field>
    </v-col>
    <v-col cols="auto" class="py-0">
      <v-img :src="qrCode" width="120"></v-img>
    </v-col>
    <v-col class="secondarytext--text subtitle-1 font-italic">
      <div class="pb-2">
        Download & print this QR code, so your team can easily scan and complete
        the survey on their mobile device.
      </div>
      <a :href="qrCode" download>
        <v-icon color="primary">download</v-icon>Download
      </a>
    </v-col>
  </v-row>
</template>

<script>
import QRCode from "qrcode";
import CopyTextField from "@/components/common/CopyTextField";
export default {
  name: "SurveyLiveLink",
  components: { CopyTextField },
  props: { instance: { type: Object } },
  data: () => ({
    qrCode: ""
  }),
  watch: {
    link(val, oldVal) {
      if (val != oldVal) {
        this.generateQR(val);
      }
    }
  },
  computed: {
    link() {
      return `${window.location.protocol}//${window.location.host}/features/surveys/${this.instance.surveyId}/${this.instance.id}/live`;
    }
  },
  created() {
    this.generateQR(this.link);
  },
  methods: {
    generateQR(text) {
      QRCode.toDataURL(text, {
        color: {
          dark: "#000000",
          light: "#0000" // Transparent background
        }
      }).then(data => {
        this.qrCode = data;
      });
    }
  }
};
</script>
